import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import CampaignService from '@forwardflow/services/CampaignService'
import useSWR from 'swr'

export function useGetOrganizationCampaignOverview(leadSource: string) {
   const response = useSWR(
      leadSource
         ? [QUERY_KEYS.CAMPAIGN_OVERVIEW_BY_LEAD_SOURCE, leadSource]
         : null,
      () =>
         leadSource ? CampaignService.getCampaignOverview(leadSource) : null
   )

   return {
      ...response,
   }
}
